// extracted by mini-css-extract-plugin
export default {"timeLine":"CasosDetails_timeLine__QLSMs"};